import jp from "jsonpath";

// const aiResponse = {
//     tangent_selfie_wrinkles: `return jp.value(selfieResponse, '$..Wrinkles.loc').length > 0;`,
//     tangent_selfie_spots: `return jp.value(selfieResponse, "$..['Dark Spots'].loc").length > 0;`,
//     tangent_selfie_dark_circles: `return jp.value(selfieResponse, "$..['Dark Circles'].loc").length > 0;`,
//     tangent_selfie_rosacea: `return jp.value(selfieResponse, '$..Rosacea.loc').length > 0;`,
//     tangent_selfie_acne: `return jp.value(selfieResponse, '$..Acne.loc').length > 0;`,
//     tangent_selfie_aging: `return jp.value(selfieResponse, '$..aging') === 'True';`,
//     tangent_selfie_wavy_hair: `return ['2a', '2b', '2c'].includes(jp.value(selfieResponse, '$..haircurl.type'));`,
//     tangent_selfie_curly_hair: `return ['3a', '3b', '3c'].includes(jp.value(selfieResponse, '$..haircurl.type'));`,
//     tangent_selfie_coily_hair: `return ['4a', '4b', '4c'].includes(jp.value(selfieResponse, '$..haircurl.type'));`,
//     tangent_selfie_straight_hair: `return jp.value(selfieResponse, '$..haircurl.type') === '1';`,
//     tangent_selfie_grey_hair: `return jp.value(selfieResponse, '$..Gray_Hair') === 'True';`,
//     tangent_selfie_hair_loss: `return jp.value(selfieResponse, '$..Receding_Hairline') === 'True';`,
// };

const checkAiSelection = (selfieResponse, tags: string | string[], aiConfig: object, aiType: object) => {
    if (!selfieResponse) return null;
    const tagSet = Array.isArray(tags) ? tags : tags.split(',');
    for (const tag of tagSet) {

        const conditionFnString = aiConfig[tag];
        if (conditionFnString) {
            const conditionFn = new Function('selfieResponse', 'jp', conditionFnString);
            if (conditionFn(selfieResponse, jp)) {
                return aiType.type
            }
        }
    }
    return null;
};

export default checkAiSelection;
